module.exports = __webpack_public_path__ + "static/media/ocd_thumb_even.68ac5297.jpg";